<template>
    <div class="corporateCultureBox">
        <aboutBannerVue tabIndex="4"></aboutBannerVue>
        <div :class="isMobile ? 'detail-mobile' : 'detail-box'" v-loading="loading" element-loading-text="加载中......">
            <div class="back-row">
                <button class="back-btn" @click="goBack">← 返回列表</button>
            </div>

            <template v-if="info">
                <h1 class="detail-title">{{ info.projectName }}</h1>

                <div class="meta-grid">
                    <div class="meta-item" v-if="info.businessType">
                        <span class="meta-label">业务类型</span>
                        <span class="meta-value">{{ info.businessType }}</span>
                    </div>
                    <div class="meta-item" v-if="info.industryType">
                        <span class="meta-label">行业类型</span>
                        <span class="meta-value">{{ info.industryType }}</span>
                    </div>
                    <div class="meta-item" v-if="info.projectInvestment != null">
                        <span class="meta-label">项目投资</span>
                        <span class="meta-value">{{ info.projectInvestment }}万元</span>
                    </div>
                    <div class="meta-item" v-if="info.serviceScope">
                        <span class="meta-label">服务范围</span>
                        <span class="meta-value">{{ info.serviceScope }}</span>
                    </div>
                    <div class="meta-item" v-if="info.addTime">
                        <span class="meta-label">发布时间</span>
                        <span class="meta-value">{{ formatDate(info.addTime) }}</span>
                    </div>
                </div>

                <div class="section" v-if="info.projectSummary">
                    <h2 class="section-title">项目概况</h2>
                    <p class="section-text">{{ info.projectSummary }}</p>
                </div>

                <div class="section" v-if="info.attachments && info.attachments.length > 0">
                    <h2 class="section-title">项目图片</h2>
                    <div class="image-grid">
                        <div class="image-item" v-for="(img, index) in info.attachments" :key="index">
                            <img :src="img.fileUrl" :alt="img.fileName" loading="lazy" @click="previewImage(img.fileUrl)">
                        </div>
                    </div>
                </div>
            </template>

            <el-empty v-if="!loading && !info" description="暂无数据"></el-empty>
        </div>

        <!-- 图片预览 -->
        <div class="preview-mask" v-if="previewUrl" @click="previewUrl = ''">
            <img class="preview-img" :src="previewUrl" alt="">
        </div>
    </div>
</template>

<script>
import aboutBannerVue from '@/components/aboutBanner'
const NEW_API_BASE = process.env.VUE_APP_NEW_API_URL || '/prod-api'
const newApi = (path) => NEW_API_BASE + path

export default {
    name: 'TypicalCaseDetail',
    components: { aboutBannerVue },
    data() {
        return {
            isMobile: false,
            info: null,
            loading: false,
            previewUrl: ''
        }
    },
    mounted() {
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
        this.getDetail();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile);
    },
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        getDetail() {
            const rowGuid = this.$route.query.rowGuid;
            if (!rowGuid) return;
            this.loading = true;
            this.Request({
                url: newApi('/hzfglSys/open/typical-case/detail'),
                method: 'get',
                data: { rowGuid: rowGuid },
                baseURL: ''
            }).then((data) => {
                if (data.data) {
                    this.info = data.data;
                }
            }).finally(() => {
                this.loading = false;
            });
        },
        formatDate(time) {
            if (!time) return '';
            return time.split(' ')[0];
        },
        goBack() {
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push('/aboutUs/TypicalPerformance');
        },
        previewImage(url) {
            this.previewUrl = url;
        }
    }
}
</script>

<style scoped lang="less">
.detail-box {
    width: 1200px;
    margin: 0 auto;
    margin-top: 40px;
    padding-bottom: 60px;
    min-height: 400px;
}

.detail-mobile {
    width: 100%;
    padding: 0 10px;
    margin-top: 20px;
    padding-bottom: 30px;
    min-height: 400px;
}

/* 返回按钮 */
.back-row {
    margin-bottom: 20px;
}

.back-btn {
    background: none;
    border: none;
    color: #247CD6;
    font-size: 14px;
    cursor: pointer;
    padding: 0;
    &:hover {
        text-decoration: underline;
    }
}

/* 标题 */
.detail-title {
    font-size: 28px;
    font-weight: bold;
    color: #333;
    line-height: 1.4;
    margin: 0 0 24px 0;
}

/* 信息网格 */
.meta-grid {
    display: flex;
    flex-wrap: wrap;
    background: #f8f9fb;
    border-radius: 8px;
    padding: 20px 24px;
    margin-bottom: 30px;
}

.meta-item {
    width: 50%;
    display: flex;
    align-items: baseline;
    margin-bottom: 12px;
    box-sizing: border-box;
    &:nth-last-child(-n+2) {
        margin-bottom: 0;
    }
}

.meta-label {
    font-size: 14px;
    color: #999;
    width: 80px;
    flex-shrink: 0;
}

.meta-value {
    font-size: 14px;
    color: #333;
    flex: 1;
}

/* 内容区块 */
.section {
    margin-bottom: 30px;
}

.section-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin: 0 0 16px 0;
    padding-left: 12px;
    border-left: 3px solid #247CD6;
}

.section-text {
    font-size: 15px;
    color: #555;
    line-height: 1.8;
    margin: 0;
    text-indent: 2em;
}

/* 图片网格 */
.image-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
}

.image-item {
    width: 260px;
    height: 180px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;
    &:hover {
        transform: scale(1.03);
        box-shadow: 0 4px 16px rgba(0,0,0,0.15);
    }
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

/* 图片预览 */
.preview-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    cursor: pointer;
}

.preview-img {
    max-width: 90%;
    max-height: 90%;
    border-radius: 4px;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    .detail-title {
        font-size: 20px;
    }

    .meta-item {
        width: 100%;
    }

    .image-item {
        width: 100%;
        height: 200px;
    }
}
</style>
